import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "border-1 fs-small lh-md" }
const _hoisted_2 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableData = _resolveComponent("TableData")!

  return (_openBlock(), _createElementBlock("tbody", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedules, (schedule, key) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: key,
        id: [schedule.isInitialize === true && _ctx.isDaily === true ? _ctx.anchor : ''],
        class: _normalizeClass(schedule.statusClass.trClass)
      }, [
        _createVNode(_component_TableData, {
          schedule: schedule,
          isMobile: _ctx.isMobile
        }, null, 8, ["schedule", "isMobile"])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}